#import "../../../common/graphql/SecureRowLevelsEntityFields.graphql"

query CommonData {
  entityDocumentUsers {
    nodes {
      userId
      userName
    }
  }
  entityDocumentPools(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  documentTypeUploads(orderBy: SORT_ORDER_ASC) {
    nodes {
      id
      documentType
    }
  }
  companyBusinessUnits {
    nodes {
      id
      name
    }
  }
  companyDepartments(
    orderBy: [NAME_ASC, PRIMARY_KEY_ASC]
    filter: { _isSystemInternal: { notEqualTo: true } }
  ) {
    nodes {
      id
      name
      _isDocSelectable
      userDepartment {
        _isUserAssigned
      }
    }
  }
  secureRowLevels(orderBy: SECURITY_LEVEL_ASC) {
    nodes {
      ...SecureRowLevelsEntityFields
    }
  }
}
